import { create } from 'zustand';
import type { CurrentUser } from '../api/auth';

interface AuthState {
  currentUser: CurrentUser | null;
  loaded: boolean;
  setCurrentUser: (user: CurrentUser | null) => void;
  setLoaded: (loaded: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  currentUser: null,
  loaded: false,
  setCurrentUser: (user) => set({ currentUser: user }),
  setLoaded: (loaded) => set({ loaded }),
}));
